import { render, staticRenderFns } from "./FormHeaderInfo.vue?vue&type=template&id=4f0977dc&scoped=true&"
import script from "./FormHeaderInfo.vue?vue&type=script&lang=js&"
export * from "./FormHeaderInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormHeaderInfo.vue?vue&type=style&index=0&id=4f0977dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0977dc",
  null
  
)

export default component.exports